module.exports = __webpack_public_path__ + "static/img/43.bff01184.gif";